import { useState } from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import DataImportPanel from "./DataImportPanel";
import DataExportPanel from "./DataExportPanel";
import SyncManagementPanel from "./SyncManagementPanel";
import { ArrowRightLeft, Download, Upload } from "lucide-react";

export default function DataExchangeTabs() {
  const [tab, setTab] = useState("import");

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Импорт / Экспорт данных</h2>
        <p className="text-sm text-muted-foreground">
          Обмен данными с внешними системами: приём ZIP-пакетов (импорт), выгрузка пакетов
          (экспорт) и синхронизация с изолированными системами (партнёры).
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="import">
            <Upload className="mr-2 h-4 w-4" />
            Импорт
          </TabsTrigger>
          <TabsTrigger value="export">
            <Download className="mr-2 h-4 w-4" />
            Экспорт
          </TabsTrigger>
          <TabsTrigger value="sync">
            <ArrowRightLeft className="mr-2 h-4 w-4" />
            Партнёры синхронизации
          </TabsTrigger>
        </TabsList>

        <TabsContent value="import" className="mt-4">
          <DataImportPanel />
        </TabsContent>
        <TabsContent value="export" className="mt-4">
          <DataExportPanel />
        </TabsContent>
        <TabsContent value="sync" className="mt-4">
          <SyncManagementPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}